// extracted by mini-css-extract-plugin
export default {"ConfettiContainer":"ilgkzI","confettiContainer":"ilgkzI","ConfettiPiece":"HUEqxw","confettiPiece":"HUEqxw","ConfettiFall":"tSdRhS","confettiFall":"tSdRhS"};